import React from 'react';
import ReactQuill from 'react-quill-new';
import { FaRegIdCard } from "react-icons/fa";
import 'react-quill-new/dist/quill.bubble.css';
import "quill-emoji/dist/quill-emoji.css";
import { FaList, FaTrash, FaCopy, FaPalette } from 'react-icons/fa6';
import LibraryModal from '../../../../../components/LibraryModal';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
// DnD Kit imports
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy
} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

function SortableCard({ card, idx, handleCardChange, handleRemoveCard, 
    handleCopyCard, listeners, attributes, isDragging, setNodeRef, style, modules, formats, handleImageClick, handleRemoveImage }) {

    return (
        <div
            ref={setNodeRef}
            style={{
                ...style,
                opacity: isDragging ? 0.5 : 1,
                background: isDragging ? "#f0f4ff" : undefined,
            }}
            className="bg-white rounded-lg shadow-md border border-gray-200 "
        >
            {/* Card Header */}
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 px-4 py-3 text-white">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div
                            className="cursor-grab hover:bg-white/20 p-1 rounded"
                            {...attributes}
                            {...listeners}
                            title="Arrastar para reordenar"
                        >
                            <FaList className="text-sm" />
                        </div>
                        <h4 className="font-semibold text-sm">Card {idx + 1}</h4>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            type="button"
                            className="text-white/80 hover:text-white p-1 rounded"
                            onClick={() => handleCopyCard(idx)}
                            title="Copiar card"
                        >
                            <FaCopy className="text-sm" />
                        </button>
                        <button
                            type="button"
                            className="text-white/80 hover:text-white p-1 rounded"
                            onClick={() => handleRemoveCard(idx)}
                            title="Remover card"
                        >
                            <FaTrash className="text-sm" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Card Content */}
            <div className="p-4 space-y-4">
                {/* Image Section */}
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                        <div
                            className="w-16 h-16 rounded-lg cursor-pointer border-2 border-dashed border-gray-300 flex items-center justify-center relative bg-gray-50 hover:bg-gray-100 transition-colors"
                            onClick={() => handleImageClick(idx)}
                            title="Clique para escolher imagem"
                        >
                            {card.imageUrl ? (
                                <img src={card.imageUrl} alt="Card" className="w-full h-full rounded-lg object-cover" />
                            ) : (
                                <span className="text-gray-400 text-xs text-center">Clique<br/>aqui</span>
                            )}
                        </div>
                        {card.imageUrl && (
                            <button
                                className="text-red-500 hover:text-red-700 p-1"
                                onClick={() => handleRemoveImage(idx)}
                                title="Remover imagem"
                            >
                                <FaTrash className="text-sm" />
                            </button>
                        )}
                    </div>
                                    {/* Content with Quill Editor */}
                <div className="space-y-1">
                    
                    <div className="border border-gray-300 rounded-lg">
                        <ReactQuill
                            theme="bubble"
                            value={card.content || ''}
                            onChange={(content) => handleCardChange(idx, "content", content)}
                            modules={modules}
                            formats={formats}
                            placeholder="Digite o conteúdo do card..."
                        />
                    </div>
                </div>
                 
                </div>

            
           



                {/* Button Configuration */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 " style={{display: 'none'}}>
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">Texto do Botão:</label>
                        <input
                            type="text"
                            value={card.buttonText || ''}
                            onChange={(e) => handleCardChange(idx, "buttonText", e.target.value)}
                            placeholder="Saiba mais"
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        />
                    </div>
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">Link do Botão:</label>
                        <input
                            type="url"
                            value={card.buttonLink || ''}
                            onChange={(e) => handleCardChange(idx, "buttonLink", e.target.value)}
                            placeholder="https://exemplo.com"
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                        />
                    </div>
                </div>

                {/* Color Configuration */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3" style={{display: 'none'}}>
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">Cor do Botão:</label>
                        <div className="flex items-center gap-2">
                            <input
                                type="color"
                                value={card.buttonColor || '#3B82F6'}
                                onChange={(e) => handleCardChange(idx, "buttonColor", e.target.value)}
                                className="w-10 h-8 border border-gray-300 rounded cursor-pointer"
                            />
                            <span className="text-xs text-gray-500">{card.buttonColor || '#3B82F6'}</span>
                        </div>
                    </div>
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">Cor de Fundo:</label>
                        <div className="flex items-center gap-2">
                            <input
                                type="color"
                                value={card.backgroundColor || '#FFFFFF'}
                                onChange={(e) => handleCardChange(idx, "backgroundColor", e.target.value)}
                                className="w-10 h-8 border border-gray-300 rounded cursor-pointer"
                            />
                            <span className="text-xs text-gray-500">{card.backgroundColor || '#FFFFFF'}</span>
                        </div>
                    </div>
                    <div className="space-y-1">
                        <label className="text-sm font-medium text-gray-700">Cor do Texto:</label>
                        <div className="flex items-center gap-2">
                            <input
                                type="color"
                                value={card.textColor || '#1F2937'}
                                onChange={(e) => handleCardChange(idx, "textColor", e.target.value)}
                                className="w-10 h-8 border border-gray-300 rounded cursor-pointer"
                            />
                            <span className="text-xs text-gray-500">{card.textColor || '#1F2937'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function DraggableCard({card, idx, handleCardChange, handleRemoveCard, handleCopyCard, modules, formats, handleImageClick, handleRemoveImage}) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: card.id || idx });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? 10 : undefined,
    };

    return (
        <SortableCard
            card={card}
            idx={idx}
            handleCardChange={handleCardChange}
            handleRemoveCard={handleRemoveCard}
            handleCopyCard={handleCopyCard}
            listeners={listeners}
            attributes={attributes}
            isDragging={isDragging}
            setNodeRef={setNodeRef}
            style={style}
            modules={modules}
            formats={formats}
            handleImageClick={handleImageClick}
            handleRemoveImage={handleRemoveImage}
        />
    );
}

export default function ConfigCards({ block, setEditingBlock, updateBlock, nodes, node, updateNode }) {
    
    // Initialize cards if undefined, similar to how ConfigQuiz handles options
    if(block.cards === undefined){
        block.cards = [
            {
                id: 'card-' + uuidv4(),
                title: "Novo Card",
                content: "Conteúdo do card...",
                imageUrl: "",
                buttonText: "Saiba mais",
                buttonLink: "",
                buttonColor: "#3B82F6",
                backgroundColor: "#FFFFFF",
                textColor: "#1F2937"
            }
        ];
    }

    console.log('configcards block', block.cards[0]?.title);
    
    const [open, setOpen] = useState(false);
    const [selectedCardIndex, setSelectedCardIndex] = useState(null);

    function handleImageClick(idx) { 
        setSelectedCardIndex(idx);
        setOpen(true);
     }

    function handleRemoveImage(idx) {
        handleCardChange(idx, "imageUrl", "");
    }

    function handleImageSelect(image) { 
        if (selectedCardIndex !== null) {
            handleCardChange(selectedCardIndex, "imageUrl", image.url || image.src || image);
            setOpen(false);
            setSelectedCardIndex(null);
            updateBlock(block.id, { ...block, cards: block.cards });
        }
    }   

    function handleCardChange(idx, field, value) {
        console.log('handleCardChange called:', { idx, field, value });
        block.cards[idx][field] = value;
        updateBlock(block.id, { ...block, cards: block.cards });
    }

    function handleAddCard() {
        if(block.cards === undefined){
            return;
        }
        const newCard = {
            id: 'card-' + uuidv4(),
            title: "Novo Card",
            content: "Conteúdo do card...",
            imageUrl: "",
            buttonText: "Saiba mais",
            buttonLink: "",
            buttonColor: "#3B82F6",
            backgroundColor: "#FFFFFF",
            textColor: "#1F2937"
        };
        block.cards.push(newCard);
        updateBlock(block.id, { ...block, cards: block.cards });
    }

    function handleRemoveCard(idx) {
        if(block.cards === undefined || block.cards.length <= 1){
            return;
        }
        block.cards.splice(idx, 1);
        updateBlock(block.id, { ...block, cards: block.cards });
    }

    function handleCopyCard(idx) {
        const cardToCopy = { ...block.cards[idx], id: 'card-' + uuidv4() };
        block.cards.push(cardToCopy);
        updateBlock(block.id, { ...block, cards: block.cards });
    }

    // DnD Kit setup
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5,
            },
        })
    );

    function handleDragEnd(event) {
        const { active, over } = event;
        if (!over || active.id === over.id) return;
        const oldIndex = block.cards.findIndex(card => (card.id || block.cards.indexOf(card)) === active.id);
        const newIndex = block.cards.findIndex(card => (card.id || block.cards.indexOf(card)) === over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        // Actually move the item in the array
        const newCards = block.cards ? arrayMove([...block.cards], oldIndex, newIndex) : [];
        block.cards = newCards;
        updateBlock(block.id, 'cards', newCards);
    }

    function handleStyleChange(e) {
        block.style = e.target.value;
        updateBlock(block.id, 'style', e.target.value);
    }

    function handleShowBorderChange(e) {
        if(e.target.value === 'true'){
            block.showBorder = true;
        } else {
            block.showBorder = false;
        }
        updateBlock(block.id, 'showBorder', block.showBorder);
    }

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean'],
        ],
    };

    const formats = [
        'header', 'font', 'bold', 'italic', 'underline', 'strike',
        'color', 'background', 'align', 'list',
        'link',  
    ];

    return (
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-4 text-white">
                <div className="flex items-center space-x-3">
                    <FaRegIdCard className="text-xl" />
                    <h3 className="text-lg font-semibold">Configuração de Cards</h3>
                </div>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6">
                {/* Layout Style Selector */}
                <div className="bg-gray-50 p-4 rounded-lg">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Estilo de Layout:</label>
                    <select 
                        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                        value={block.style || 'list'} 
                        onChange={handleStyleChange}
                    >
                        <option value="list">Lista (1 coluna)</option>
                        <option value="2-columns">2 Colunas</option>
                        <option value="3-columns">3 Colunas</option>
                        <option value="4-columns">4 Colunas</option>
                    </select>
                </div>


                <div className="bg-gray-50 p-4 rounded-lg">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Mostrar Bordas:</label>
                    <select 
                        className="w-full p-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent" 
                        value={block.showBorder ? 'true' : 'false'} 
                        onChange={handleShowBorderChange}
                    >
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                    </select>
                </div>

                {/* Cards List */}
                <div className="space-y-4">
                    <div className="flex items-center justify-between">
                        <label className="text-sm font-medium text-gray-700">Cards:</label>
                        <button
                            type="button"
                            className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition-colors flex items-center gap-2"
                            onClick={handleAddCard}
                        >
                            <span>+</span>
                            Adicionar Card
                        </button>
                    </div>

                    <div className="bg-gray-50 p-4 rounded-lg space-y-4">
                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                        >
                            <SortableContext
                                items={block.cards.map((card, idx) => card.id || idx)}
                                strategy={verticalListSortingStrategy}
                            >
                                {block.cards.length === 0 && (
                                    <div className="text-gray-500 text-sm text-center py-8">
                                        Nenhum card adicionado ainda.
                                    </div>
                                )}
                                {block.cards.map((card, idx) => (
                                    <DraggableCard
                                        key={card.id || idx}
                                        card={card}
                                        idx={idx}
                                        handleCardChange={handleCardChange}
                                        handleRemoveCard={handleRemoveCard}
                                        handleCopyCard={handleCopyCard}
                                        modules={modules}
                                        formats={formats}
                                        handleImageClick={handleImageClick}
                                        handleRemoveImage={handleRemoveImage}
                                    />
                                ))}
                            </SortableContext>
                        </DndContext>
                    </div>
                </div>
            </div>
            
            <LibraryModal
                open={open}
                onClose={() => {
                    setOpen(false);
                    setSelectedCardIndex(null);
                }}
                onSelect={handleImageSelect}
            />
        </div>
    );
} 